import React from 'react';
import PropTypes from 'prop-types';

export const BulkMMAConvertEditorHeader = ({
  i18n,
  selectedRowCount,
}) => (
  <div className="panel-heading" role="heading" aria-level="2">
    <div className="panel-title" data-bind="text: bulkConversionTitle">{i18n.getString(_TL_('Copy responsive search ads to Multimedia ads ({{count}} ads selected)'), { count: selectedRowCount })}</div>
    <div className="description" style={{ fontWeight: 'normal' }}>{i18n.getString(_TL_('Your existing responsive search ads will continue to serve after you copy them to Multimedia ads.'))}</div>
  </div>
);

BulkMMAConvertEditorHeader.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  selectedRowCount: PropTypes.number.isRequired,
};
